export function isPC () {
  let userAgentInfo = navigator.userAgent

  let Agents = [
    'Android',
    'iPhone',
    'SymbianOS',
    'Windows Phone',
    'iPad',
    'iPod',
    'pad',
    'pod',
    'Mobile'
  ]

  let flag = true

  for (let i = 0; i < Agents.length; i++) {
    if (userAgentInfo.indexOf(Agents[i]) > 0) {
      flag = false

      break
    }
  }

  // 获取屏幕宽度
  var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth

  return flag && screenWidth > 870
}



// WEBPACK FOOTER //
// ./src/util/index.js